import { useVisit } from '~/features/visits/VisitContext';
import { useGetVisitStatusOptions } from '~/features/visits/queries';
import { useQuery } from '@tanstack/react-query';
import { VisitOrderFooter } from './VisitOrderFooter';
import { VisitBucketItemWrapper } from '../shared/VisitBucketItemWrapper';
import { Order } from '~/features/orders/Order';
import { useVisitEvaluation } from '~/features/frequencies/evaluations/VisitEvaluationContext';

export function CompleteOrderVisitBucket() {
	const { id } = useVisit();
	const { refetch: refetchVisitStatus } = useQuery(useGetVisitStatusOptions(id));
	const evaluationContext = useVisitEvaluation();
	if (!evaluationContext) {
		throw new Error('CompleteOrderVisitBucket must be used within a VisitEvaluationProvider');
	}

	return (
		<VisitBucketItemWrapper footerSlot={<VisitOrderFooter fullOrder={evaluationContext.fullOrder} />}>
			<Order fullOrder={evaluationContext.fullOrder} />
		</VisitBucketItemWrapper>
	);
}
